<template>
  <span class="coupon-badge">
    <SmallLightningBolt />
    Coupon Applied
  </span>
</template>
<script setup lang="ts">
import SmallLightningBolt from '@/components/icons/SmallLightningBolt.vue'
</script>

<style lang="scss" scoped>
.coupon-badge {
  font-family: $font-family-pilat-demi;
  font-size: 14px;
  height: 28px;
  display: flex;
  align-items: center;
  border-radius: 24px;
  padding: 0 12px 0 8px;
  background: var(--color-badge);
  color: var(--color-white);

  svg {
    margin-right: 4px;
  }
}
</style>
